import React, { useState, useContext, useMemo } from "react";
import { ReactComponent as PreviewLessonIcon } from "../../../assets/icons/HeaderIcons/preview-lesson-icon.svg";
import {
  ILessonPageActionsContext,
  LessonPageActionsContext,
  PageContext,
  IPageContext,
} from "../../../routes/builderContexts";
import { AbstractTooltip as Tooltip } from "../../ToolTip/ToolTip";
import { useObjectsState } from "../../../contexts/ObjectsProvider";
import { useInteracitvityHotspotState } from "../../../contexts/InteractivityHotspotProvider";
import classes from "../../../utils/HTML/classes";
function FilePart(bigPath: string): string {
  const group = bigPath.split("/");
  const filename = group[group.length - 1];
  return filename;
}

type LessonModes = "Demo" | "Practice" | "Perform";

const PagePreview: React.FC<any> = (props: any) => {
  const lessonPageActions: ILessonPageActionsContext = useContext<ILessonPageActionsContext>(LessonPageActionsContext);
  const pageContext: IPageContext = useContext<IPageContext>(PageContext);
  const objectsState = useObjectsState();
  const interactivityHotspotState = useInteracitvityHotspotState();
  const [dropDownVisible, setDropDownVisible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] =
    useState<boolean>(false);

  const pageNumber = pageContext.computedPageIndex;
  // const pageNumber = pageContext.currentAggregationOrder
  //   ? pageContext.currentAggregationOrder + pageContext.currentlyDisplayedPageIndex
  //   : props.pagenumber;

  const link = "/api/PassThru/cpat/lesson/lessonpreview/" + props.lessonVersionId + ".preview/index.html";

  let previewLinkI = link + "?clasmode=Instructional";
  let previewLinkP = link + "?clasmode=Practice";
  let previewLinkT = link + "?clasmode=Test";

  let previewText = "Preview";
  if (undefined != pageNumber) {
    previewLinkI = previewLinkI + "&previewpageindex=" + pageNumber;
    previewLinkP = previewLinkP + "&previewpageindex=" + pageNumber;
    previewLinkT = previewLinkT + "&previewpageindex=" + pageNumber;
    previewText = "Page Preview";
  } else {
  }

  function canUse() {
    switch (lessonPageActions.previewMode) {
      case "Demo":
        return previewLinkI;
      case "Practice":
        return previewLinkP;
      case "Perform":
        return previewLinkT;
    }
    return "";
  }
  const aProps =
    lessonPageActions.dirt === 0 &&
    !objectsState.needSave &&
    !interactivityHotspotState.needSave &&
    !isDisabledLessonMode(lessonPageActions.previewMode)
      ? { href: canUse(), target: "_blank" }
      : {};
  function isDisabledLessonMode(mode: string) {
    let x = 0;
    switch (mode) {
      case "Demo":
        x = 1;
        break;
      case "Practice":
        x = 2;
        break;
      case "Perform":
        x = 3;
        break;
    }

    if (pageContext.page && pageContext.page.lessonModeIds) {
      if (pageContext.page.lessonModeIds.includes(x)) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  const isDisabled = isDisabledLessonMode(lessonPageActions.previewMode);

  return (
    <div className={classes("pageEditorActionListerRow", { disabled: isDisabled })}>
      <div className="pageListerActionButton preview-icon">
        <a
          className="page-previewButtonContainer"
          {...aProps}
          data-tooltip-id="Preview Page"
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div>
            <PreviewLessonIcon />
          </div>
          <p>
            Page Preview{" "}
            {isDisabled
              ? "(Mode Disabled)"
              : lessonPageActions.dirt !== 0 || objectsState.needSave || interactivityHotspotState.needSave
              ? "(Save Lesson)"
              : ""}
          </p>
        </a>
        <Tooltip id="Preview Page" />
      </div>
    </div>
  );
};

export default PagePreview;
